import { getUA } from 'core/singleton'

interface PartnerExecutor {
  [key: string]: {
    gtmCustomUrl?: string
    isGADisabled?: boolean
    isIOSWebview?: boolean
    isUseAlarm?: boolean
    isUseLiveCancellation?: boolean
    appendSearchParamsToProductUrl?: (productUrl: URL) => URL
    reqMoveBroadcastBridge?: (moveUrl: string) => boolean
    reqMoveMainPageBridge?: () => boolean
  }
}

const _partnerExecutor: PartnerExecutor = {
  butterand: {
    isGADisabled: true,
  },
  kbpay: {
    isIOSWebview: navigator.userAgent.match(/iPhone|iPad|iPod/i) !== null,
    isUseLiveCancellation: true,
    reqMoveBroadcastBridge: (moveUrl: string) => {
      const json = `{
        "common": {
          "callback": "callback"
        },
        "screenId": "kbp_life_005",
        "svcSceDtcd": "1",
        "moveUrl": "${moveUrl}"
      }`
      if (getUA().isAOS && window.kbpayBridge) {
        window.kbpayBridge.goNativeScreen(json)
        return true
      }
      /** ENGAGE-130 iOS 판단 처리는 getUA().isIOS를 사용하면 KBPay앱에서 정상 동작하지 않음 */
      if (_partnerExecutor.kbpay?.isIOSWebview && window.webkit) {
        window.webkit.messageHandlers?.goNativeScreen?.postMessage(json)
        return true
      }

      return false
    },
    reqMoveMainPageBridge: () => {
      const json = `{
        "common": {
          "callback": "callback"
        },
        "menuDsc": "",
        "menuNm": "",
        "moveUrl": "",
        "params": "",
        "screenId": "kbp_life_001",
        "svcSceDtcd": "2"
      }`
      if (getUA().isAOS && window.kbpayBridge) {
        window.kbpayBridge.goNativeScreen(json)
        return true
      }
      /** ENGAGE-130 iOS 판단 처리는 getUA().isIOS를 사용하면 KBPay앱에서 정상 동작하지 않음 */
      if (_partnerExecutor.kbpay?.isIOSWebview && window.webkit) {
        window.webkit.messageHandlers?.goNativeScreen?.postMessage(json)
        return true
      }

      return false
    },
  },
  'lg-uplus': {
    gtmCustomUrl: 'https://gatag.uplus.co.kr',
    isGADisabled: true,
    isUseAlarm: true,
  },
  uiux: {
    isUseAlarm: true,
  },
  memberQA: {
    isUseAlarm: true,
    appendSearchParamsToProductUrl: (productUrl: URL): URL => {
      productUrl.searchParams.append('sauce_from', 'live')
      return productUrl
    },
  },
  nmemberQA: {
    isUseAlarm: true,
  },
  shinsegaelive: {
    appendSearchParamsToProductUrl: (productUrl: URL): URL => {
      productUrl.searchParams.append('sauce_from', 'live')
      return productUrl
    },
  },
  qwerQA: {
    isUseAlarm: true,
  },
}

export const getExecutorForPartner = (partnerId: string | undefined) => {
  if (!partnerId) return undefined
  return partnerId ? _partnerExecutor[partnerId] : undefined
}
